module.exports = __webpack_public_path__ + "static/profile-pic-c2506323a568773ade5a598440316135.jpg";